import { createSlice, createSelector } from '@reduxjs/toolkit';

const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    sidebarCollapsed: false,
    breadcrumbs: [],
  },
  reducers: {
    addBreadcrumb: (state, action) => {
      // @ts-ignore
      state.breadcrumbs = [...state.breadcrumbs, action.payload].sort((a, b) => a.path.length - b.path.length);
    },
    removeBreadcrumb: (state, action) => {
      // @ts-ignore
      state.breadcrumbs = state.breadcrumbs.filter((breadcrumb) => action.payload !== breadcrumb.path);
    },
    setSidebar: (state, action) => {
      state.sidebarCollapsed = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      // @ts-ignore
      window.localStorage.setItem('sidebarCollapsed', state.sidebarCollapsed);
    },
  },
});

// @ts-ignore
const selectLayout = (state) => state.layout;

const selectSidebarCollapsed = createSelector(selectLayout, (layout) => layout.sidebarCollapsed);

const selectBreadcrumbs = createSelector(selectLayout, (layout) => layout.breadcrumbs);

const layoutReducer = layoutSlice.reducer;
const { addBreadcrumb, removeBreadcrumb, setSidebar, toggleSidebar } = layoutSlice.actions;

export {
  layoutReducer,
  selectBreadcrumbs,
  selectSidebarCollapsed,
  selectLayout,
  addBreadcrumb,
  removeBreadcrumb,
  setSidebar,
  toggleSidebar,
};






